export default {
    listagem: {
        titulo_pagina: 'Lista de Componentes',
        novo: 'Crear Nuevo Componente',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró ningún componente',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Componente',
            editar: 'Editar Componente'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código del Componente'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre del Componente'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo del componente'
            },
            botao_salvar : 'Guardar Componente'
        },
        create: {
            success: '¡Componente creado con éxito!',
            error: '¡Error al crear el componente!'
        },
        update: {
            success: '¡Componente editado con éxito!',
            error: '¡Error al editar el componente!'
        }
    }
}
